// @flow
import {
    CACHE_PRODUCT_TEMPERATURE,
    CHANGE_ALL_PRODUCT_STATES,
    CHANGE_PRODUCT_STATE,
    CHANGED_PRODUCT_STATE,
    SET_HUMIDIFIER_TYPE
} from './constants';

import { createAction } from 'redux-actions';

export const cacheProductTemperature = createAction(CACHE_PRODUCT_TEMPERATURE);
export const changeAllProductStates = createAction(CHANGE_ALL_PRODUCT_STATES);
export const changeProductState = createAction(CHANGE_PRODUCT_STATE);
export const changedProductState = createAction(CHANGED_PRODUCT_STATE);
export const setHumidifierType = createAction(SET_HUMIDIFIER_TYPE);



// WEBPACK FOOTER //
// ./src/core/state/products/thermostat/actions.js